import type { fastCleanGroupsUpdate } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.actions';
import type { QuotaCleaneFastGroup, QuotaCleanerState } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import type { UserQuotaGroupId } from 'reactApp/types/QuotaCleaner';

export const fastCleanGroupsUpdateReducer = (state: QuotaCleanerState, action: ReturnType<typeof fastCleanGroupsUpdate>) => {
    const clearedGroups = action.payload;

    const clearedGroupToClearedInfo = clearedGroups.reduce((acc, group) => {
        acc[group.groupId] = group;
        return acc;
    }, {} as Record<UserQuotaGroupId, (typeof clearedGroups)[number]>);

    const fastCleanGroups: QuotaCleaneFastGroup[] = state.fastCleanState.fastCleanGroups.map((group) => {
        const { cleared: clearedInfo, isSuccess } = clearedGroupToClearedInfo[group.groupId] || {};

        if (!clearedInfo) {
            return group;
        }

        return {
            ...group,
            cleared: {
                count: (group?.cleared?.count || 0) + clearedInfo.count,
                size: (group?.cleared?.size || 0) + clearedInfo.size,
            },
            cleaningState: isSuccess
                ? {
                      isCleanLoading: false,
                      isCleanLoaded: true,
                      isCleanSuccess: true,
                      isCleanError: false,
                  }
                : {
                      isCleanLoading: true,
                      isCleanLoaded: false,
                      isCleanSuccess: false,
                      isCleanError: false,
                  },
        };
    });

    const fastCleanGroupsIds = state.fastCleanState.fastCleanGroups.map((group) => group.groupId);
    const total = state.groups
        .filter((group) => fastCleanGroupsIds.includes(group.groupId))
        .reduce((acc, group) => acc + group.size_uniq, 0);

    const cleaned = fastCleanGroups.reduce((acc, group) => {
        return acc + (group?.cleared?.size || 0);
    }, 0);

    let cleanedPercent = Math.round((cleaned * 100) / total);
    cleanedPercent = Math.min(cleanedPercent, 100);

    return {
        ...state,
        fastCleanState: {
            ...state.fastCleanState,
            cleaningState: {
                ...state.fastCleanState.cleaningState,
                cleanedPercent,
            },
            fastCleanGroups,
        },
    };
};
